import { environment } from '../../../environments/environment';

export const api_base_url = environment.api_base_url;